import { splitCamelCase } from '@Utils/helpers/stringHelpers';
import DeleteIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { Tooltip } from '@mui/material';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import FolderFieldsSelector from '../FolderFieldSelector';
import Styles from '../Processes.scss';

const MultiFieldSelectorOption = (props) => {
    const {
        canDelete,
        folderFields,
        title,
        onChangeField,
        index,
        value,
        onDelete,
        id,
    } = props;

    const label = !canDelete ? splitCamelCase(title, true) : null;

    const handleSelectField = (newValue) => {
        onChangeField(newValue, index);
    };

    const handleDelete = () => {
        onDelete(index);
    };

    return (
        <div
            id={id}
            className={cx(
                Styles.spFolderInputs,
                canDelete ? Styles.spMfsoChild : null
            )}
        >
            <div className={Styles.spFolderLabelContainer}>{label}</div>
            <div className={Styles.spLeftMargin}>
                <FolderFieldsSelector
                    id={`${id}-selector`}
                    folderFields={folderFields}
                    onSelectFolderField={handleSelectField}
                    selectedFolderField={value}
                />
            </div>
            {canDelete && (
                <div className={Styles.spMfsoDelete}>
                    <Tooltip title="Remove field">
                        <DeleteIcon
                            id={`${id}-delete-btn`}
                            onClick={handleDelete}
                        />
                    </Tooltip>
                </div>
            )}
        </div>
    );
};

MultiFieldSelectorOption.propTypes = {
    index: PropTypes.string,
    folderFields: PropTypes.array,
    title: PropTypes.string,
    onChangeField: PropTypes.func,
    canDelete: PropTypes.bool,
    value: PropTypes.string,
    onDelete: PropTypes.func,
    id: PropTypes.string,
};
export default MultiFieldSelectorOption;
